import { render } from "./ColumnAnnounce.vue?vue&type=template&id=5ceae749&scoped=true"
import script from "./ColumnAnnounce.vue?vue&type=script&lang=js"
export * from "./ColumnAnnounce.vue?vue&type=script&lang=js"

import "./ColumnAnnounce.vue?vue&type=style&index=0&id=5ceae749&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ceae749"]])

export default __exports__